
function Dipoespgestdocumental() {
    return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Gestión Documental y Archivos Digitales 
                    brinda formación integral sobre métodos, herramientas y normativas 
                    aplicables a la administración documental en el sector público.
               </p>
               <p>
                    El programa aborda clasificación documental, digitalización, conservación 
                    de archivos, seguridad de la información y sistemas de gestión documental.
               </p>

                <h1> Objetivo Específico </h1>
                <ul>
                    <li>
                        Desarrollar competencias técnicas para implementar sistemas 
                        de gestión documental y archivos digitales, garantizando 
                        conservación, seguridad y acceso eficiente a la información.
                    </li>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_gestion_biblioteca.webp' 
                    alt='gestion-documental' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Clasificación Documental </li>
                    <li> 2. Gestión de Expedientes </li>
                    <li> 3. Digitalización y Conservación </li>
                    <li> 4. Seguridad de la Información </li>
                    <li> 5. Sistemas de Gestión Documental </li>
                    <li> 6. Normativa Vigente </li>
                </ul>
            </div>
        </div>
    );
}

export default Dipoespgestdocumental